import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import ItAssetListLayer from '../components/ItAssetListLayer'

const ItAssetListPage = () => {
  return (
    <MasterLayout>
        <Breadcrumb title='IT Asset List' />
        <ItAssetListLayer />
    </MasterLayout>
  )
}

export default ItAssetListPage

